var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaffRequestResourcePageIcons3 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0039,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_50334_80309)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.8869 5.60938H6.23599C5.95351 5.60938 5.6826 5.72159 5.48286 5.92133C5.28311 6.12108 5.1709 6.39198 5.1709 6.67446V17.3254C5.1709 17.6078 5.28311 17.8787 5.48286 18.0785C5.6826 18.2782 5.95351 18.3904 6.23599 18.3904H16.8869C17.1694 18.3904 17.4403 18.2782 17.64 18.0785C17.8397 17.8787 17.952 17.6078 17.952 17.3254V6.67446C17.952 6.39198 17.8397 6.12108 17.64 5.92133C17.4403 5.72159 17.1694 5.60938 16.8869 5.60938ZM16.8869 17.3254H6.23599V14.6626H8.14582L9.43125 15.9487C9.52992 16.0478 9.64726 16.1264 9.77649 16.1799C9.90573 16.2334 10.0443 16.2607 10.1841 16.2603H12.9387C13.0786 16.2607 13.2173 16.2333 13.3465 16.1797C13.4758 16.1261 13.5931 16.0474 13.6916 15.9481L14.977 14.6626H16.8869V17.3254Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_50334_80309",
  x1: 6.50391,
  y1: 1,
  x2: 16.0039,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1EAED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C8FF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaffRequestResourcePageIcons3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/staff_request_resource_page_icons3.e11a38c6c4f16f8069503c4c088711ef.svg";